import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import useLocalStorage from "use-local-storage";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import "../../Home/components/Main.scss";
import "./Writing.scss";

const articles = [
  {
    slug: "fx-market-structure",
    title: "FX Market Structure",
    date: "May 2025",
  },
  {
    slug: "anticlustering-multi-objective-optimization",
    title: "Anticlustering and Multi-Objective Optimization",
    date: "September 2024",
  },
  {
    slug: "rate-varying-poisson-mmpp",
    title: "The varied rate Poisson Process and MMPP",
    date: "June 2024",
  },
];

const WritingList = () => {
  const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [theme, setTheme] = useLocalStorage(
    "theme",
    defaultDark ? "dark" : "light"
  );

  const switchTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
  };

  return (
    <div className="main" data-theme={theme}>
      <div className="mid-section">
        <div className="header">
          <button className="switcher" onClick={switchTheme}>
            {theme === "light" ? (
              <FontAwesomeIcon size={"2x"} icon={faMoon} className="icon" />
            ) : (
              <FontAwesomeIcon size={"2x"} icon={faSun} className="icon" />
            )}
          </button>
        </div>
        <div className="section">
          <div className="section-title">
            <p>Back</p>
          </div>
          <div className="section-text">
            <p>
              <Link className="link" to="/">
                ← Home
              </Link>
            </p>
          </div>
        </div>
        <div className="section">
          <div className="section-title">
            <p>Writing</p>
          </div>
          <div className="section-text">
            {articles.map((article) => (
              <p key={article.slug}>
                <Link className="link" to={`/writing/${article.slug}`}>
                  {article.title}
                </Link>
                {"  "}
                <span className="article-date">{article.date}</span>
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WritingList;
